/*
 * サブシステム名：入金
 * 機能名：入金一覧
 */
import { mapGetters } from 'vuex'
import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import validators from '@/rahmen/validators'

import header from '@/ddv2.library/header'

const DdSearchList = () => import('@/components/DdSearchList')
const DdCodeTextBox = () => import('../../components/DdCodeTextBox.vue')
const DdDateRangeBox = () => import('@/components/DdDateRangeBox')
const DdRadioButton = () => import('@/components/DdRadioButton')
const DdTextBox = () => import('@/components/DdTextBox')

export default {
  name: 'NyukinList',
  mixins: [flowMixin],
  components: {
    DdSearchList,
    DdCodeTextBox,
    DdDateRangeBox,
    DdRadioButton,
    DdTextBox
  },
  data: () => ({
    // 一覧制御用
    selected: [],
    itemsPerPage: 100,
    page: 1,
    isConditionHide: false,
    isCsvDownloader: false,
    isPdfDownloader: false,

    conditions: {
      shubetsu: '',
      torihikisakiCd: '',
      nyukinStartYmdString: '',
      nyukinEndYmdString: '',
      kinyuKikanCd: '',
      kinyuKikanShitenCd: ''
    },
    headersNyukinsakiList: header.mstTorihikisakiHeaders,
    modeKengen: 0
  }),
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      helpUseFlg: 'DDMasters/helpUseFlg',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      nyukinsakiList: 'DDMasters/vwCMstTorihikisakiGetNyukinsaki'
    }),
    filteredRows () {
      console.log('filter', this.rows)
      return this.rows.map((elem) => {
        if (elem.shubetsu === '入金予定表') {
          elem.genkinDisp = ''
          elem.furikomiKingakuDisp = ''
          elem.furikomiTesuryoDisp = ''
          elem.tegataDisp = ''
          elem.kogitteDisp = ''
          elem.choseiKingakuDisp = ''
          elem.sosaiKingakuDisp = ''
        } else {
          elem.genkinDisp = elem.genkin ? filter.numericFormatter(elem.genkin) : ''
          elem.furikomiKingakuDisp = elem.furikomiKingaku ? filter.numericFormatter(elem.furikomiKingaku) : ''
          elem.furikomiTesuryoDisp = elem.furikomiTesuryo ? filter.numericFormatter(elem.furikomiTesuryo) : ''
          elem.tegataDisp = elem.tegata ? filter.numericFormatter(elem.tegata) : ''
          elem.kogitteDisp = elem.kogitte ? filter.numericFormatter(elem.kogitte) : ''
          elem.choseiKingakuDisp = elem.choseiKingaku ? filter.numericFormatter(elem.choseiKingaku) : ''
          elem.sosaiKingakuDisp = elem.sosaiKingaku ? filter.numericFormatter(elem.sosaiKingaku) : ''
        }
        elem.nyukinYmdDisp = filter.dateFormatter(elem.nyukinYmd)
        elem.nyukinGokeiKingakuDisp = elem.nyukinGokeiKingaku ? filter.numericFormatter(elem.nyukinGokeiKingaku) : ''

        return elem
      })
    },
    isCsvButtonDisabled () {
      return this.rows.length === 0
    },
    filteredTorihikisakiList () {
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.torihikisakiCd > elem2.torihikisakiCd) { return 1 }
        if (elem1.torihikisakiCd === elem2.torihikisakiCd) { return 0 }
        return -1
      })
    },
    filteredNyukinsakiList () {
      const target = filter.dateFormatter(new Date())
      return this.nyukinsakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.torihikisakiCd > elem2.torihikisakiCd) { return 1 }
        if (elem1.torihikisakiCd === elem2.torihikisakiCd) { return 0 }
        return -1
      })
    },

    isAddButtonDisplay () {
      if (this.modeKengen === 0) {
        return false
      }
      return true
    },
    isShubetsu () {
      console.log('●●isShubetsu：', this.conditions.shubetsu)
      if (this.conditions.shubetsu === '0') {
        return true
      } else {
        return false
      }
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['msttorihikisaki', 'vwcmsttorihikisakigetnyukinsaki'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('NyukinList.defineHeaderPromise')
            self.headers = [
              { text: '編集', value: 'actions', sortable: false, width: '20px' },
              { text: '入金No', value: 'nyukinNo' },
              { text: '入金年月日', value: 'nyukinYmdDisp', align: 'center' },
              { text: '入金担当者', value: 'tantoshaNm' },
              { text: '入金先コード/名称', value: 'torihikisakiNm' },
              { text: '合計', value: 'nyukinGokeiKingakuDisp', align: 'end' },
              { text: '現金', value: 'genkinDisp', align: 'end' },
              { text: '振込', value: 'furikomiKingakuDisp', align: 'end' },
              { text: '振込手数料', value: 'furikomiTesuryoDisp', align: 'end' },
              { text: '手形', value: 'tegataDisp', align: 'end' },
              { text: '小切手', value: 'kogitteDisp', align: 'end' },
              { text: '調整', value: 'choseiKingakuDisp', align: 'end' },
              { text: '相殺', value: 'sosaiKingakuDisp', align: 'end' },
              { text: '銀行コード/名称', value: 'kinyuKikanNm' },
              { text: '支店コード/名称', value: 'shitenNm' },
              { text: '摘要', value: 'tekiyo' },
              { text: '区分', value: 'shubetsu' }
            ]
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.conditions = {
              shubetsu: '0',
              torihikisakiCd: '',
              nyukinStartYmdString: '',
              nyukinEndYmdString: '',
              kinyuKikanCd: '',
              kinyuKikanShitenCd: ''
            }
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('NyukinList.savedInputRestorePromise', c)
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                console.log('NyukinList.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('NyukinList.researchPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            // self.$set(self.conditions, 'nyukinStartYmdString', self.conditions.nyukinStartYmdString)
            // self.$set(self.conditions, 'nyukinEndYmdString', self.conditions.nyukinEndYmdString)
            this.$nextTick(function () {
              this.onSearchButtonClick()
              document.getElementById('heavy-element').style.display = ''
            })
            resolve()
            // self.search().then(() => {
            //   resolve()
            // })
          })
        },
        restoreViewPromise: (c) => {
          console.log('NyukinList.restoreViewPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            self.searchText = c.cache.value ? c.cache.value.searchText || '' : self.searchText
            self.rows = c.cache.value ? c.cache.value.rows || [] : self.rows
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('NyukinList.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    onSearchButtonClick: function (e) {
      this.selected = []
      this.page = 1

      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/VwCD2depd001001/search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload

          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
              return {
              }
            })
        },
        getSavedInputMethod: function () {
          return {}
        }
      }
      this.search(opt)
    },

    clear: function () {
      console.log('clear pushed')
      const self = this
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            self.conditions = {
              shubetsu: '0',
              torihikisakiCd: '',
              nyukinStartYmdString: '',
              nyukinEndYmdString: '',
              kinyuKikanCd: '',
              kinyuKikanShitenCd: ''
            }
            self.searchText = ''
            self.rows = []
            self.selected = []
            self.page = 1
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onClearButtonClick: function (e) {
      console.log('clear pushed')
      this.Effects.loadStart()
      this.clear()
    },
    onRowDoubleClick: function (e, f) {
      console.log(e, f)
      if (f.item.shubetsu !== '入金予定表') {
        this.Effects.loadStart()
        this.transition(0, { id: f.item.id })
      }
    },
    onRowEditButtonClick: function (item) {
      // 画面遷移
      if (item.shubetsu !== '入金予定表') {
        this.Effects.loadStart()
        this.transition(0, { id: item.id })
      }
    },
    onCsvButtonClick: function (e) {
      this.Effects.loadStart()
      this.HttpClient
        .post('/api/v1/VwCD2depd001001/download', this.conditions)
        .then((data) => {
          const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
          const blob = new Blob([bom, data], { type: 'text/csv' })
          const elem = document.getElementById('download')
          elem.href = window.URL.createObjectURL(blob)
          elem.click()
          this.Effects.loadComplete()
        })
    },
    onCreateButtonClick: function (e) {
      console.log(e)
      this.Effects.loadStart()
      this.transition(0, { id: 0 })
    },
    onPdfButtonClick: function (e) {
      this.Effects.loadStart()
      this.HttpClient
        .requestFileByPost('/api/v1/VwCD2depd001001/pdfdownload', this.conditions)
        .then((data) => {
          const blob = new Blob([data], { type: 'application/pdf' })
          const elem = document.getElementById('pdfdownload')
          elem.href = window.URL.createObjectURL(blob)
          elem.click()
          this.Effects.loadComplete()
        })
    },
    searchValidate: function () {
      console.log('●●searchVaridate:', this.$refs)
      var msg = validators.compareDate(this.conditions.nyukinStartYmdString, this.conditions.nyukinEndYmdString)
      if (msg !== undefined) {
        this.$refs.nyukinStartYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
        this.$refs.nyukinEndYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
        return false
      }
      return true
    }
  }
}
